// extracted by mini-css-extract-plugin
export var externalLink = "_9w-0";
export var internalLinkLabel = "_9w-1";